import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const DYNAMIC_MISSION_REPORT_ROUTE = {
  name: 'dynamicmissionreport/:missionId',
  route(classId: string, missionId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), 'dynamicmissionreport', missionId];
  }
};
